<template>
  <div>
    <el-card class="box-card" style="margin-top: 10px">
      <div slot="header" class="clearfix">
        <span>退出配置</span>
      </div>

      <el-form>
        <el-row :gutter="24">
          <el-col :span="6">
            <el-form-item label="分钟">
              <el-input v-model.number="join.minutes" placeholder="分钟" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="次数">
              <el-input v-model.number="join.count" placeholder="次数" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-button type="primary" @click="onSubmit()">保存</el-button>

      </el-form>
    </el-card>

  </div>
</template>

<script>
import { getCommonCfg, updateCommonCfg } from '@/api/config/common-cfg'

export default {
  name: 'Join',
  data() {
    return {
      key: 'CLUB_CONFIG:SHOW_JOIN_QUIT',
      join: { 'minutes': 5, 'count': 1 }
    }
  },
  created() {
    this.getTables()
  },
  methods: {
    getTables() {
      getCommonCfg({ name: this.key }).then(res => {
        this.join = res.data
      })
    },
    onSubmit() {
      const data = JSON.stringify(this.join)
      updateCommonCfg({ data: data, name: this.key }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
